import React from 'react'
import classNames from 'classnames'
import Button from 'material-ui/Button'

export default ({ value, className, ...rest }) => (
  <Button raised color="primary" type="submit" className={classNames('wide', className)} {...rest}>
    {value}
  </Button>
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/submit.js